// File: /src/components/Toolbar.js

import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';
import TableViewIcon from '@mui/icons-material/TableView';
import '../styles/Toolbar.css';
import { toast } from 'react-toastify';

function GridClientsToolbar({
	viewMode,
	onAddClient,
	onGeneratePdf,
	onGenerateXlsx,
	onChangeView,
	selectedCount,
	onArchiveSelected,
	onUnarchiveSelected,
	isShowingArchived,
}) {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleViewChange = (event, newView) => {
		if (newView !== null) {
			onChangeView(newView);
		}
	};

	const handleArchiveAction = () => {
		if (selectedCount === 0) {
			toast.warning('Selecione pelo menos um item para arquivar/desarquivar');
			return;
		}
		if (isShowingArchived) {
			onUnarchiveSelected();
		} else {
			onArchiveSelected();
		}
		handleMenuClose();
	};

	return (
		<AppBar position="static" className="toolbar-appbar">
			<Toolbar className="toolbar-container">
				<ToggleButtonGroup
					value={viewMode}
					exclusive
					onChange={handleViewChange}
					size="small"
					className="toolbar-toggle-group"
				>
					<ToggleButton
						value="grid"
						className="toolbar-toggle-button"
						aria-label="Visualização em Grade"
						title="Visualização em Grade"
					>
						<GridViewIcon />
					</ToggleButton>
					<ToggleButton
						value="list"
						className="toolbar-toggle-button"
						aria-label="Visualização em Lista"
						title="Visualização em Lista"
					>
						<ViewListIcon />
					</ToggleButton>
					<ToggleButton
						value="table"
						className="toolbar-toggle-button"
						aria-label="Visualização em Tabela"
						title="Visualização em Tabela"
					>
						<TableViewIcon />
					</ToggleButton>
				</ToggleButtonGroup>
				<IconButton
					onClick={handleMenuOpen}
					className="toolbar-menu-button"
				>
					<MoreVertIcon />
				</IconButton>
				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={handleMenuClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
				>
					<MenuItem
						onClick={() => {
							onAddClient();
							handleMenuClose();
						}}
						className="toolbar-menu-item"
					>
						Adicionar Cliente
					</MenuItem>
					<MenuItem
						onClick={handleArchiveAction}
						className="toolbar-menu-item"
					>
						{isShowingArchived ? "Desarquivar Itens" : "Arquivar Itens"}
					</MenuItem>
					<MenuItem
						onClick={() => {
							onGeneratePdf();
							handleMenuClose();
						}}
						className="toolbar-menu-item"
					>
						Gerar Relatório PDF
					</MenuItem>
					<MenuItem
						onClick={() => {
							onGenerateXlsx();
							handleMenuClose();
						}}
						className="toolbar-menu-item"
					>
						Gerar Relatório XLSX
					</MenuItem>
				</Menu>
			</Toolbar>
		</AppBar>
	);
}

export default GridClientsToolbar;
